//Years to have flexible control over different league info
export const PLL_FIRST_YEAR: number = 2019
export const YEAR_MIN = 2001
export const YEAR_MAX = 2025
export const CURRENT_YEAR: number = 2025
export const STANDINGS_YEAR: number = 2025
export const EVENTS_YEAR: number = 2025
export const STATS_YEAR = 2025
export const DRAFT_YEAR = 2025
export const prevDraftYearsList = [2024, 2023, 2022, 2021, 2020, 2019]
export const VERIFIED_YEAR = 2024

//Controls if we show Champ Series specific components
export const isChampSeriesLive = true
//Ability to manual set without knowing events - used in Standings context
export const hasChampSeriesStarted = true

type CSDateRanges = {
  [key: number]: {
    startTime: number
    endTime: number
  }
}

//For controlling if we show champ series on player profiles
export const champSeriesDateRanges: CSDateRanges = {
  2024: {
    startTime: 1707949800,
    endTime: 1716703404,
  },
  2025: {
    startTime: 1739260800,
    endTime: 1740124800,
  },
}

//Controls if we events in schedule or not
export const incompleteMarkets: string[] = []

export const addToCalendarIds: { [key: string]: string } = {
  league: 'Wc849139',
}

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
]
export const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const shortDays = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']

type ChampIdType = {
  [key: string]: number
}

export const CHAMPIONSHIP_IDS: ChampIdType = {
  2023: 228,
  2022: 124,
}
